export const DATE_PART_EXPRESSION_FIELD_ALIAS_PREFIX = 'datePart_expression_';